export const getCenterCoordinates = () => {
  const center: any = {
    lat: 35.72858,
    lng: 137.9344
  }
  return center
}
